import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import { ExportRounded } from '../../../../assets/icons'
import { XSmallSecondaryButton } from '../../../../components/Button'
import { mobileFullWidth } from '../../../../components/buttonStyles'

const Pill = styled(XSmallSecondaryButton)`
  /* The glyph is inset inside its 30px box, so this reads as the design's wider gap. */
  gap: 4px;
  padding: 0 20px;
  font-weight: 400;
  line-height: 22px;
  white-space: nowrap;

  ${mobileFullWidth};
`

const Glyph = styled(ExportRounded)`
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
`

/** Compact "Upload statement" action shown beside the other investment controls. */
const UploadStatementButton = ({ onClick, className }) => (
  <Pill type='button' onClick={onClick} className={className}>
    <Glyph />
    Upload statement
  </Pill>
)

UploadStatementButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default UploadStatementButton
